(() => {
  const zeroDecimalCurrencies = new Set(['BIF','CLP','DJF','GNF','ISK','JPY','KMF','KRW','PYG','RWF','UGX','UYI','VND','VUV','XAF','XOF','XPF','CRC','IDR']);

  const friendlyIncrement = (amount) => {
    if (amount < 250) return 5;
    if (amount < 1000) return 10;
    if (amount < 2500) return 50;
    if (amount < 25000) return 500;
    if (amount < 100000) return 1000;
    if (amount < 250000) return 5000;
    if (amount < 1000000) return 10000;
    return Math.pow(10, Math.max(0, Math.floor(Math.log10(amount)) - 1));
  };

  const roundUpFriendly = (amount) => {
    const increment = friendlyIncrement(amount);
    return Math.ceil((amount - Number.EPSILON) / increment) * increment;
  };

  const formatMarketAmount = (amount, currency, locale, maximumFractionDigits) => {
    let formatted;
    try {
      formatted = new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: maximumFractionDigits,
        maximumFractionDigits,
      }).format(amount);
    } catch (_) {
      formatted = new Intl.NumberFormat('en', {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: maximumFractionDigits,
        maximumFractionDigits,
      }).format(amount);
    }
    /* Generic English may render CAD as "$". Keep the currency explicit. */
    if (currency === 'CAD' && !/(?:CA|CAD)/i.test(formatted)) formatted = formatted.replace('$', 'CA$');
    return formatted;
  };

  const updateMarketShippingMessages = (root = document) => {
    const shopifyCurrency = window.Shopify?.currency || {};
    const rawRate = shopifyCurrency.rate;
    const rate = Number(rawRate || 1);
    root.querySelectorAll('[data-al-market-shipping-message]').forEach((message) => {
      const currency = message.dataset.currency || shopifyCurrency.active || 'EUR';
      const validRate = currency === 'EUR' || (rawRate != null && Number.isFinite(rate) && rate > 0);
      if (!validRate) return;
      const locale = document.documentElement.lang || undefined;
      const baseRate = Number(message.dataset.baseRate || 4.9);
      const baseThreshold = Number(message.dataset.baseThreshold || 45);
      const fractionDigits = zeroDecimalCurrencies.has(currency) ? 0 : 2;
      const shippingRate = formatMarketAmount(baseRate * rate, currency, locale, fractionDigits);
      const freeThreshold = formatMarketAmount(roundUpFriendly(baseThreshold * rate), currency, locale, 0);
      const template = message.dataset.template || '';
      if (!template.includes('__AL_RATE__') && !template.includes('__AL_THRESHOLD__')) return;
      message.textContent = template
        .replaceAll('__AL_RATE__', shippingRate)
        .replaceAll('__AL_THRESHOLD__', freeThreshold);
      message.dataset.marketReady = 'true';
      message.dataset.currency = currency;
    });
  };

  const update = (root, cart) => {
    root.querySelectorAll('[data-al-cart-delivery]').forEach((card) => {
      const currency = card.dataset.currency || cart.currency || window.Shopify?.currency?.active || 'EUR';
      const rate = Number(window.Shopify?.currency?.rate || 1);
      const unit = zeroDecimalCurrencies.has(currency) ? 1 : 100;
      const threshold = roundUpFriendly(Number(card.dataset.baseThreshold || 45) * rate) * unit;
      const total = Number(cart.total_price || 0);
      const remaining = Math.max(0, threshold - total);
      const progress = Math.max(0, Math.min(100, threshold ? total / threshold * 100 : 100));
      const bar = card.querySelector('[data-al-shipping-progress]');
      const output = card.querySelector('[data-al-shipping-progress-copy]');
      const copyNode = card.querySelector('[data-al-shipping-copy]');
      let copy = {};
      try { copy = JSON.parse(copyNode?.textContent || '{}'); } catch (_) {}
      if (bar) bar.style.width = `${progress}%`;
      if (!output) return;
      if (remaining <= 0) {
        output.textContent = copy.unlocked || '';
        return;
      }
      const formatted = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency, maximumFractionDigits: zeroDecimalCurrencies.has(currency) ? 0 : 2
      }).format(remaining / unit);
      output.textContent = String(copy.remaining || '').replace('[[amount]]', formatted);
    });
  };

  const initialCart = (root = document) => {
    const card = root.querySelector('[data-al-cart-delivery]');
    if (!card) return null;
    const total = Number(card.dataset.cartTotal);
    return Number.isFinite(total) ? {total_price: total} : null;
  };

  const refresh = (root = document) => {
    if (!root.querySelector('[data-al-cart-delivery]')) return Promise.resolve();
    return fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: {Accept: 'application/json'}
    }).then((response) => response.json()).then((cart) => update(root, cart)).catch(() => {});
  };

  const start = () => {
    updateMarketShippingMessages();
    const cart = initialCart();
    if (cart) update(document, cart);
    else refresh();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  ['cart:updated','cart:refresh','cart:change'].forEach((eventName) => document.addEventListener(eventName, (event) => {
    const cart = event.detail?.cart;
    if (cart) update(document, cart);
    else refresh();
  }));
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target || document;
    updateMarketShippingMessages(root);
    const cart = initialCart(root);
    if (cart) update(root, cart);
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) updateMarketShippingMessages(document);
  });
})();
